import React from 'react';
import './pattern.css';

export default function Pattern({ data }){
    return(
        <div className="pattern posr">
            <div className="pattern-shadow-top"></div>
            <div className="banner tac">
                <h4 className="mb1">{data.caption}</h4>
                <h1 className="">{data.title}</h1>
                <h2 className="fwb">{data.subtitle}</h2>
            </div>
            <div className="pattern-shadow-bottom"></div>
        </div>
    )
}